import cn from 'bem-cn';

import { Stack } from '../Stack';

import { ListProps } from './List.types';
import './List.scss';

const b = cn('list');

export const List = <T, >(props: ListProps<T>) => {
    const { items, renderItem, keyExtractor, className, ...stackProps } = props;

    return (
        <Stack as="ul" className={b.mix(className)} {...stackProps}>
            {items.map((item, index) => {
                const key = keyExtractor(item, index);

                return <li key={key}>{renderItem(item, index)}</li>;
            })}
        </Stack>
    );
};
